import { useState, useCallback } from "react"
import { ILocationLink } from "./data"
import { BTS_PAGE_MOBILE_URL } from "../constant"

interface IUseBtsDetail {
  mobileUrl: string
  locationLinks: ILocationLink[]
  openImageModalState: boolean
  openImageModal: () => void
  closeImageModal: () => void
}

interface IOption {
  [k: string]: any
}

type UseBtsDetail = (
  locationLinks: ILocationLink[],
  option?: IOption
) => IUseBtsDetail

export const useBtsDetail: UseBtsDetail = (locationLinks = [], option = {}) => {
  const [openImageModalState, setImageModalState] = useState<boolean>(false)

  const openImageModal = useCallback(() => {
    setImageModalState(true)
  }, [])

  const closeImageModal = useCallback(() => {
    setImageModalState(false)
  }, [])

  return {
    mobileUrl: BTS_PAGE_MOBILE_URL,
    locationLinks,
    openImageModalState,
    openImageModal,
    closeImageModal,
  }
}
